<template>
  <div>
    <div class="dyy print-container" id="dy" ref="htmlDom">
      <div id="datas" v-if="student" style="width: 100%;margin: 0 auto;display: flex;justify-content: center">
        <div id="baseData" style="width: 1050px;">
          <div class="base-data">
            <div class="base-title">
              <span>{{ student.name }}</span>
              <span class="m-l-20">高考志愿填报档案表</span>
            </div>

            <div class="base-table">
              <div class="base-tr title-th">
                <div class="txt-l">基本信息</div>
              </div>
              <div class="base-tr-other">
                <div>学生姓名</div>
                <div>{{ student.name }}</div>
                <div>科类</div>
                <div>{{ student.major | filterMajor }}</div>
                <div>性别</div>
                <div>{{ student.sex == 0 ? '男' : '女' }}</div>
                <div>年龄</div>
                <div>{{ student.age }}</div>
                <div>出生日期</div>
                <div>{{ student.birthdayDate }}</div>
              </div>
              <div class="base-tr-other">
                <div>政治面貌</div>
                <div>{{ student.politic }}</div>
                <div>民族</div>
                <div>{{ student.nation }}</div>
                <div>考生类别</div>
                <div>{{ student.stuType }}</div>
                <div>外语语种</div>
                <div>{{ student.languagesMsg }}</div>
                <div>高考年份</div>
                <div>{{ student.other }}</div>
              </div>
              <div class="base-tr-other">
                <div style="width: 10%">身高(cm)</div>
                <div style="width: 10%">{{ student.height }}</div>
                <div style="width: 10%">体重(kg)</div>
                <div style="width: 10%">{{ student.weight }}</div>
                <div style="width: 10%">视力</div>
                <div style="width: 50%">{{ student.vision }}</div>
              </div>
              <div class="base-tr-other">
                <div style="width: 10%">其他情况</div>
                <div style="width: 40%">{{ student.others }}</div>
                <div style="width: 10%">体检结论</div>
                <div style="width: 40%">
                  <span v-for="(item, index) in chooseMedical">{{ item }}<span
                      v-if="index != (chooseMedical.length - 1)">，</span></span>
                </div>
              </div>
              <div class="base-tr-other">
                <div style="width: 10%">就读学校</div>
                <div style="width: 40%">{{ student.school }}</div>
                <div style="width: 10%">户籍地址</div>
                <div style="width: 40%">{{ student.address }}</div>
              </div>
              <div class="base-tr-other" v-for="(item, index) in student.stuContacts">
                <div class="w-10">{{ index == 0 ? '主联系人' : '次联系人' }}</div>
                <div class="w-10">{{ item.name }}</div>
                <div class="w-10">关系</div>
                <div class="w-10">{{ item.relationship }}</div>
                <div class="w-10">职业</div>
                <div class="w-20">{{ item.occupation }}</div>
                <div class="w-10">电话</div>
                <div class="w-20">{{ item.phone }}</div>
              </div>
              <div class="base-tr title-th">
                <div class="txt-l">考试成绩</div>
              </div>
              <div class="base-tr score-tr">
                <div class="flex-2">考试名称</div>
                <div class="flex-8">
                  <div>语文</div>
                  <div>数学</div>
                  <div>外语</div>
                  <div>物理</div>
                  <div>化学</div>
                  <div>生物</div>
                  <div>综合</div>
                  <div>总分</div>
                  <div>位次</div>
                  <div>口试</div>
                  <div>备注</div>
                </div>
              </div>
              <div class="base-tr score-tr" v-for="(item, index) in student.stuAchievements">
                <div class="flex-2">{{ item.examName }}</div>
                <div class="flex-8">
                  <div>{{ item.language ? item.language : '/' }}</div>
                  <div>{{ item.mathematics ? item.mathematics : '/' }}</div>
                  <div>{{ item.foreignLanguages ? item.foreignLanguages : '/' }}</div>
                  <div>{{ item.physics ? item.physics : '/' }}</div>
                  <div>{{ item.chemistry ? item.chemistry : '/' }}</div>
                  <div>{{ item.biology ? item.biology : '/' }}</div>
                  <div>{{ item.comprehensive ? item.comprehensive : '/' }}</div>
                  <div>{{ item.totalScore ? item.totalScore : '/' }}</div>
                  <div>{{ item.ranking ? item.ranking : '/' }}</div>
                  <div>{{ item.oralTest ? item.oralTest : '/' }}</div>
                  <div>{{ item.remarks ? item.remarks : '/' }}</div>
                </div>
              </div>
              <div class="base-tr title-th">
                <div class="txt-l">升学通道</div>
              </div>
              <div class="base-tr">
                <div>
                  <div class="txt-l checked-section" v-for="(item, index) in channelsFirstData" :key="index">
                    <div class="checked-box" :class="{ 'checked-box-active': item.value }" style="width: 100%;">
                      <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                      <div v-else class="inner-box"></div>
                      <span>{{ item.label }}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="txt-l checked-section" v-for="(item, index) in channelsSecondData" :key="index">
                    <div class="checked-box" :class="{ 'checked-box-active': item.value }" style="width: 100%;">
                      <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                      <div v-else class="inner-box"></div>
                      <span>{{ item.label }}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="txt-l checked-section" v-for="(item, index) in channelsThirdData" :key="index">
                    <div class="checked-box" :class="{ 'checked-box-active': item.value }" style="width: 100%;">
                      <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                      <div v-else class="inner-box"></div>
                      <span>{{ item.label }}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="txt-l checked-section" v-for="(item, index) in channelsForthData" :key="index">
                    <div class="checked-box" :class="{ 'checked-box-active': item.value }" style="width: 100%;">
                      <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                      <div v-else class="inner-box"></div>
                      <span>{{ item.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="base-tr">
                <div class="remark-box">{{ student.remarks }}</div>
              </div>
              <div class="base-tr title-th" style="border-bottom: 0;">
                <div class="txt-l">报考意向</div>
              </div>
              <div class="base-tr" v-if="student.examMsg">
                <div class="intention-apply-tr">
                  <div class="apply-left">方案倾向</div>
                  <div class="apply-right">
                    <div class="b-r-l p-0-10 txt-l checked-section">
                      <div class="checked-box" v-for="(item, index) in student.examMsg.scheme" :key="index"
                        :class="{ 'checked-box-active': item.value }">
                        <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                        <div v-else class="inner-box"></div>
                        <span>{{ item.label }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="base-tr" v-if="student.examMsg">
                <div class="intention-apply-tr">
                  <div class="apply-left">大学规划</div>
                  <div class="apply-right">
                    <div class="b-r-l p-0-10 txt-l checked-section">
                      <div class="checked-box" v-for="(item, index) in student.examMsg.universityPlanning" :key="index"
                        :class="{ 'checked-box-active': item.value }">
                        <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                        <div v-else class="inner-box"></div>
                        <span>{{ item.label }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="base-tr" v-if="student.examMsg">
                <div class="intention-apply-tr">
                  <div class="apply-left">合作办学</div>
                  <div class="apply-right">
                    <div class="b-r-l p-0-10 txt-l checked-section">
                      <div class="checked-box" v-for="(item, index) in student.examMsg.cooperativeSchool" :key="index"
                        :class="{ 'checked-box-active': item.value }">
                        <img v-if="item.value" class="inner-box-active" src="~@/assets/images/icon_check.png" alt="">
                        <div v-else class="inner-box"></div>
                        <span>{{ item.label }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="base-tr">
                <div class="intention-apply-tr" v-if="student.examMsg">
                  <div class="apply-left">志愿意向</div>
                  <div class="apply-right">
                    <div class="child-box">
                      <div class="child-left">意向学校</div>
                      <div class="child-right txt-l">{{ student.examMsg.intentionApply.schoolName || '/' }}</div>
                    </div>
                    <div class="child-box">
                      <div class="child-left">意向专业</div>
                      <div class="child-right txt-l">{{ student.examMsg.intentionApply.professionName || '/' }}</div>
                    </div>
                    <div class="child-box">
                      <div class="child-left">意向职业</div>
                      <div class="child-right txt-l">{{ student.examMsg.intentionApply.occupationName || '/' }}</div>
                    </div>
                    <div class="child-box">
                      <div class="child-left">意向城市</div>
                      <div class="child-right txt-l">{{ student.examMsg.intentionApply.cityName || '/' }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="base-tr title-th">
                <div class="txt-l">备注说明</div>
              </div>
              <div class="base-tr">
                <div class="remark-box">{{ student.others }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧按钮 -->
      <div id="npt">
        <br>
        <el-button style="background-color: #1264ff;color: white;margin-top: 20px;" circle v-print="'#baseData'">打印
        </el-button>
        <br>
        <el-button style="background-color: #7870b6;color: white;margin-top: 20px;" circle @click="getPdf('#datas')">下载
        </el-button>
        <br>
        <el-button style="background-color: green;color: white;margin-top: 20px;" circle @click="goBack()">返回
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/util/request";
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

// 科类
const MajorData = [
  {
    label: '物理类',
    value: 1
  },
  {
    label: '历史类',
    value: 2
  },
  {
    label: '物理',
    value: 3
  },
  {
    label: '历史',
    value: 4
  },
]

const ChannelsSecondData = [
  {
    label: '军队院校',
    value: false
  },
  {
    label: '公安本科专业',
    value: false
  },
  {
    label: '中国消防救援学院',
    value: false
  },
  {
    label: '司法本科专业',
    value: false
  },
  {
    label: '定向培养军士',
    value: false
  },
  {
    label: '公安高职 (专科) 专业',
    value: false
  },
  {
    label: '免费医学定向生',
    value: false
  }
];
const ChannelsThirdData = [
  {
    label: '北京电子科技学院',
    value: false
  },
  {
    label: '公费师范生',
    value: false
  },
  {
    label: '优师专项',
    value: false
  },
  {
    label: '航海类专业',
    value: false
  },
  {
    label: '小语种',
    value: false
  },
  {
    label: '种子科学与工程',
    value: false
  },
  {
    label: '全国重点马克思主义学院',
    value: false
  }
];
const ChannelsForthData = [
  {
    label: '国家专项计划',
    value: false
  },
  {
    label: '地方专项计划',
    value: false
  },
  {
    label: '定向就业',
    value: false
  },
  {
    label: '民族班',
    value: false
  },
  {
    label: '少数民族预科班',
    value: false
  },
  {
    label: '四川大学预科班',
    value: false
  },
  {
    label: '边防军子女预科班',
    value: false
  },
];

export default {

  data() {
    return {
      loading: false,
      // tab 导航
      activeName: "first",
      // 基本资料
      channelsFirstData: [
        { label: '强基计划', value: false },
        { label: '综合评价', value: false },
        { label: '港、澳独立招生', value: false },
        { label: '飞行技术专业', value: false },
        { label: '高水平运动队', value: false },
        { label: '高校专项计划', value: false },
        { label: '空乘、民航空中安保', value: false }
      ],
      channelsSecondData: ChannelsSecondData.concat([]),
      channelsThirdData: ChannelsThirdData.concat([]),
      channelsForthData: ChannelsForthData.concat([]),
      student: null,
      printOption: {
        id: 'baseData', // 打印元素的id 不需要携带#号
      },
      chooseMedical: [], // 体检结论
      userId: null,
      studentm: [],
      stuId: '',

    }
  },
  filters: {
    filterMajor(value) {
      const major = MajorData.find((item) => item.value == value)
      return major.label
    },
  },
  created() {
    this.baseInitializeFn()
  },
  mounted() {
  },
  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 下载pdf
    getPdf(url) {
      let title = ''
      if (url == '#programmes') {
        title = this.student.name + "方案信息";
        window.open(`${this.$constants.serverUrl}/mendaoVoluntary/stuSchemeV2/getPrintSchemePdf?stuId=` + this.stuId);
        return;
      } else if (url == '#datas') {
        title = this.student.name + "高考志愿填报档案表";
      } else if (url == '#newschool') {
        title = this.student.name + "选科方案";
      } else if (url == '#majors') {
        title = this.student.name + "专业方向";
      }

      html2Canvas(document.querySelector(url), {
        allowTaint: true,
        taintTest: false,
        logging: false,
        useCORS: true,
        dpi: window.devicePixelRatio * 1.5, //将分辨率提高到特定的DPI 提高四倍
        // dpi:300,
        scale: 1.5 //按比例增加分辨率
      }).then(canvas => {
        var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向

        var ctx = canvas.getContext('2d'),
          a4w = 260, a4h = 280,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
        while (renderedHeight < canvas.height) {
          var page = document.createElement("canvas");
          page.width = canvas.width;
          page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页

          //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
          pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', -25, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距

          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) {
            pdf.addPage();//如果后面还有内容，添加一个空页
          }
        }
        //保存文件
        pdf.save(title + '.pdf')

      })
    },

    // 获取体检结论
    getNotAdmitted() {
      request({
        method: 'POST',
        url: 'stuArchivesRel/getNotAdmitted',
        params: {
          stuid: this.student.id
        }
      }).then(res => {
        let list = []
        res.data.xz.forEach(i => {
          list.push(i.code.toString())
        })
        this.chooseMedical = list
      })
    },

    // 获取学生信息
    getStu() {
      request({
        method: 'get',
        url: 'students/getStu',
        params: {
          Id: this.userId
        }
      }).then(res => {
        this.student = res.data
        this.stuId = this.student.id
        this.student.examMsg = JSON.parse(this.student.examMsg)
        this.getNotAdmitted()
      })
    },
    // 整理强基计划内容
    formatCheckMsg() {
      if (!this.student.checkMsg) {
        return
      }
      this.student.checkMsg.forEach(e => {
        this.channelsFirstData.forEach(data => {
          if (e === data.label) {
            data.value = true
          }
        })
        this.channelsSecondData.forEach(data => {
          if (e === data.label) {
            data.value = true
          }
        })
        this.channelsThirdData.forEach(data => {
          if (e === data.label) {
            data.value = true
          }
        })
        this.channelsForthData.forEach(data => {
          if (e === data.label) {
            data.value = true
          }
        })
      })
    },
    // 基础信息表格内容获取
    baseInitializeFn() {
      const user = this.$store.getters.userInfo
      this.userId = user.userId
      if (user.userType == 3) {
        this.student = JSON.parse(localStorage.getItem('stu'))
        this.stuId = this.student.id
        this.student.examMsg = JSON.parse(this.student.examMsg)
        this.student.checkMsg = JSON.parse(this.student.checkMsg)
        this.getNotAdmitted()
        this.formatCheckMsg()
      } else if (user.userType == 4) {
        this.student = JSON.parse(localStorage.getItem('stu'))
        this.getStu()
      }
    }
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
// 颜色定义规范
$color-background = #fff
$color-background-d = rgba(0, 0, 0, 0.3)
$color-highlight-background = #333
$color-dialog-background = #666
$color-theme = #e96558
$color-theme-d = rgba(233, 101, 88, 0.5)

$color-text = #fff
$color-text-e = rgba(0, 0, 0, 0.1)
$color-text-d = rgba(0, 0, 0, 0.3)
$color-text-l = rgba(0, 0, 0, 0.5)
$color-text-ll = rgba(0, 0, 0, 0.8)

body, html {
  height: inherit
}

.jc {
  font-weight: bold;
}

.jl {
  font-size: 18px;
  font-weight: bold;
  margin-right: 2%;
  display: inline-block;
  width 10em
  margin-top 10px
}

.tp {
  width 100%
  margin auto
  line-height 30px
}

.dyy #xx .el-checkbox-button__inner {
  width: 40px;
  height: 25px;
}

#dy #npt {
  top: 20%;
  right 5%;
  z-index: 99999;
  position: fixed;
}

#dy #npt1 {
  top: 20%;
  z-index: 99999;
  position: fixed;
  right 5%;
}

#npt1 button {
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 15px;
  font-weight: initial;
  padding: 0;
  text-align: center;
}

#npt1 button span {
  display: inline-block;
  margin: auto;
}

#dy {
  font-size 15px
  -webkit-print-color-adjust: exact
}

@media print {
  #baseData, #programme, #newschools, #major {

    * {
      -webkit-print-color-adjust: exact;
      -moz-print-color-adjust: exact;
      -ms-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    border: solid 1px #fff;
  }

}

#programmes table tr {

  page-break-inside: avoid;

}

#newschool table tr {

  page-break-inside: avoid;

}

//#dy .el-table {
//  border-color black
//  border-bottom 1px solid #000000
//  border-right 1px solid #000000
//}

#tables {
  width: 400px; //表格的宽度
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  border-spacing: 0; /*把单元格间隙设置为0*/
  // font-family: "宋体"
}

#tables th, td {
  height: 40px;
  font-weight: 400;
}

#result {
  tr {
    border-bottom 1px solid #d4d4d4
    height 50px
  }
}


</style>

<style lang="stylus" scoped>
pageWidth = 1400px
$color-theme = #f96630
$color-table-border = #999

.print-container
  width: pageWidth;
  margin: 0 auto;
  font-size: 14px;

  div
    box-sizing: border-box;

  .m-l-20
    margin-left 20px

  .b-r-l
    border-left: 1px solid $color-table-border;
  .b-r-r
    border-right: 1px solid $color-table-border;
  .p-0-10
    padding: 0 10px;
</style>

<style scoped media="print">
/*指定打印的分页*/

/*
/deep/ section {
  page-break-after: always;
}
*/
/*避免出现空白尾页*/
html,
body,
#app {
  height: 98% !important;
  margin: 0px;
  padding: 0px;
}
</style>
<style scoped>
.print-container {
  width: 1400px;
  margin: 0 auto;
  font-size: 14px;
}

.print-container div {
  box-sizing: border-box;
}

.m-l-20 {
  margin-left: 20px
}

.m-t-20 {
  margin-top: 20px
}

.b-r-l {
  border-left: 1px solid #999;
}

.b-r-r {
  border-right: 1px solid #999;
}

.p-0-10 {
  padding: 0 10px;
}

.txt-l {
  text-align: left !important;
}

.base-data {
  width: 1050px;
  margin: auto;
  padding: 0;
}

.base-data .base-title {
  width: 100%;
  margin-top: 50px;
  font-size: 25px;
  color: #333;
  font-weight: 600;
  text-align: center
}

.base-data .base-table {
  margin: 50px auto;
  border: 1px solid #999;
}

.base-data .base-tr,
.base-tr-other {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #999;
}

.base-data .base-tr:last-child {
  border-bottom: none
}

.base-data .base-tr>div {
  flex: 1;
  min-height: 33px;
  line-height: 33px;
  padding: 0 10px;
  text-align: center;
  border-right: 1px solid #999
}

.base-data .base-tr>div:last-child {
  border-right: none
}

.base-data .base-tr-other>div {
  width: 10%;
  min-height: 33px;
  line-height: 33px;
  padding: 0 10px;
  text-align: center;
  border-right: 1px solid #999
}

.base-data .base-tr-other>div:nth-child(2n-1) {
  font-weight: 600;
}

.base-data .base-tr-other>div:last-child {
  border-right: none;
}

.base-data .title-th {
  font-size: 16px;
  font-weight: 600;
}

.base-data .remark-box {
  min-height: 60px !important;
  text-align: left !important;
}

.base-data .base-tr-other .w-10 {
  width: 10%;
  padding: 0 !important;
}

.base-data .base-tr-other .w-20 {
  width: 20%;
  padding: 0 !important;
}

.base-data .base-tr .flex-4 {
  flex: 4;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
}

.base-data .base-tr .flex-8 {
  flex: 8;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
  display: flex;
  align-items: center;
}

.base-data .base-tr .flex-8>div {
  flex: 1;
  min-height: 33px;
  text-align: center;
  border-right: 1px solid #999
}

.base-data .base-tr .flex-8>div:last-child {
  border-right: none
}

.base-data .base-tr .intention-apply-tr {
  display: flex;
  align-items: center;
  padding: 0 !important;
}

.base-data .apply-left {
  flex: 1;
}

.base-data .apply-right {
  flex: 9;
}

.base-data .apply-right .el-checkbox {
  width: 80px;
}

.base-data .checked-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.base-data .checked-section .checked-box {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.base-data .checked-section .checked-box-active {
  color: #f96630;
}

.base-data .checked-section .checked-box .inner-box {
  position: relative;
  margin-right: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
}

.base-data .checked-section .checked-box .inner-box-active {
  position: relative;
  margin-right: 10px;
  border: 1px solid #f96630;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
}

.base-data .child-box {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #999;
}

.base-data .child-box:last-child {
  border-bottom: none;
}

.base-data .child-left {
  flex: 1.5;
  padding: 0 10px;
  border-left: 1px solid #999;
  border-right: 1px solid #999;
}

.base-data .child-right {
  flex: 8.5;
  padding: 0 10px;
}

.base-data .score-tr div {
  flex: 0.7;
}
</style>
